import React, { useState } from 'react';
import { collection, addDoc, doc, updateDoc, query, where, getDocs, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { useNavigate } from 'react-router-dom';

function generateInviteCode() {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    let code = '';
    for (let i = 0; i < 6; i++) code += chars[Math.floor(Math.random() * chars.length)];
    return code;
}

function SetupTeam({ user, userData }) {
    const [mode, setMode] = useState(null); // 'create' | 'join'
    const [teamName, setTeamName] = useState('');
    const [inviteCode, setInviteCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleCreateTeam = async () => {
        if (!teamName.trim()) return;
        setLoading(true);
        setError('');
        try {
            const code = generateInviteCode();
            const teamRef = await addDoc(collection(db, 'teams'), {
                name: teamName.trim(),
                ownerId: user.uid,
                ownerName: user.displayName || '',
                inviteCode: code,
                memberCount: 1,
                createdAt: serverTimestamp(),
            });

            // Update user with teamId
            await updateDoc(doc(db, 'users', user.uid), {
                teamId: teamRef.id,
                teamRole: 'owner',
                role: 'admin',
            });

            // Force reload to pick up new teamId
            window.location.href = '/';
        } catch (err) {
            console.error('Team create error:', err);
            setError('Баг үүсгэхэд алдаа гарлаа');
        } finally {
            setLoading(false);
        }
    };

    const handleJoinTeam = async () => {
        if (!inviteCode.trim()) return;
        setLoading(true);
        setError('');
        try {
            const code = inviteCode.trim().toUpperCase();
            const q = query(collection(db, 'teams'), where('inviteCode', '==', code));
            const snap = await getDocs(q);

            if (snap.empty) {
                setError('Урилга код олдсонгүй. Дахин шалгана уу.');
                setLoading(false);
                return;
            }

            const teamDoc = snap.docs[0];
            const teamId = teamDoc.id;

            // Update user with teamId
            await updateDoc(doc(db, 'users', user.uid), {
                teamId: teamId,
                teamRole: 'member',
                role: 'user',
            });

            // Increment member count
            const currentCount = teamDoc.data().memberCount || 1;
            await updateDoc(doc(db, 'teams', teamId), {
                memberCount: currentCount + 1,
            });

            window.location.href = '/';
        } catch (err) {
            console.error('Team join error:', err);
            setError('Багт нэгдэхэд алдаа гарлаа');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex-container center-content">
            <div className="glass-card login-card" style={{ maxWidth: 420 }}>
                <div className="login-icon">🏢</div>
                <h2 style={{ marginBottom: '0.5rem' }}>Баг тохируулах</h2>
                <p className="subtitle" style={{ marginBottom: '1.5rem' }}>
                    Та шинэ баг үүсгэх эсвэл урилга кодоор нэгдэх боломжтой
                </p>

                {error && <div className="error-message" style={{ marginBottom: '1rem' }}>{error}</div>}

                {!mode && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                        <button className="btn btn-primary" onClick={() => setMode('create')}
                            style={{ padding: '0.9rem', fontSize: '1rem' }}>
                            ✨ Шинэ баг үүсгэх
                        </button>
                        <button className="btn btn-secondary" onClick={() => setMode('join')}
                            style={{ padding: '0.9rem', fontSize: '1rem' }}>
                            🔗 Урилга кодоор нэгдэх
                        </button>
                    </div>
                )}

                {mode === 'create' && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                        <div className="form-group" style={{ marginBottom: 0 }}>
                            <label>🏢 Багийн нэр</label>
                            <input type="text" value={teamName}
                                onChange={e => setTeamName(e.target.value)}
                                placeholder="Жишээ: Гандантэгчинлэн хийд"
                                autoFocus />
                        </div>
                        <button className="btn btn-primary" onClick={handleCreateTeam}
                            disabled={loading || !teamName.trim()}
                            style={{ padding: '0.9rem' }}>
                            {loading ? <><span className="spinner"></span> Үүсгэж байна...</> : '✨ Баг үүсгэх'}
                        </button>
                        <button className="btn btn-secondary" onClick={() => { setMode(null); setError(''); }}
                            style={{ padding: '0.7rem', fontSize: '0.85rem' }}>
                            ← Буцах
                        </button>
                    </div>
                )}

                {mode === 'join' && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                        <div className="form-group" style={{ marginBottom: 0 }}>
                            <label>🔗 Урилга код</label>
                            <input type="text" value={inviteCode}
                                onChange={e => setInviteCode(e.target.value.toUpperCase())}
                                placeholder="6 оронтой код оруулах"
                                maxLength={6}
                                style={{ textAlign: 'center', fontSize: '1.5rem', letterSpacing: '0.3rem', fontWeight: 700 }}
                                autoFocus />
                        </div>
                        <button className="btn btn-primary" onClick={handleJoinTeam}
                            disabled={loading || inviteCode.trim().length < 6}
                            style={{ padding: '0.9rem' }}>
                            {loading ? <><span className="spinner"></span> Нэгдэж байна...</> : '🔗 Нэгдэх'}
                        </button>
                        <button className="btn btn-secondary" onClick={() => { setMode(null); setError(''); }}
                            style={{ padding: '0.7rem', fontSize: '0.85rem' }}>
                            ← Буцах
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default SetupTeam;
